<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <div class="row m-t-20">
        <div class="col-lg-12">
          <h5 class="d-inline">
            {{ principleIndex }}. {{ principle.description }}
          </h5>
          <p v-if="principle.objective" class="m-t-0">
            {{ principle.objective }}
          </p>
          <template v-if="principle.criteria.length === 0">
            <template v-for="indicator in indicators">
              <indicator :id="indicator.control_point_id" :key="indicator.control_point_id" :auditId="auditId" :auditor="auditor" :indicator="indicator" :name="indicator.control_point_name.substr(indicator.control_point_name.lastIndexOf(' '))" :status="auditStatus" />
            </template>
          </template>
          <ul id="pills-tab" class="nav nav-tabs custom-tab" role="tablist">
            <li v-for="(criteria, index) in principle.criteria" :key="index" class="nav-item" @click="tab(criteria.criterion)">
              <a :class="{'active': activeTab === criteria.criterion}" class="nav-link" data-toggle="pill" role="tab" :href="'#'+criteria.criterion">
                <template v-if="auditStatus === 'InProgress'">
                  <i class="fa fa-th-list m-r-10" />
                </template>
                {{ principleIndex }}.{{ index+1 }}
                <span v-if="criteria" :title="criteria.description" data-placement="right" data-toggle="tooltip">
                  {{ criteria.description | truncate(30, '...') }}
                </span>
              </a>
            </li>
          </ul>
          <!-- Tab panes -->
          <div v-for="(criterion, index) in principle.criteria" :id="criterion.criterion" :key="index" :class="{'show': activeTab === criterion.criterion}" class="tab-pane active mt-5" role="tabpanel">
            <criteria v-if="activeTab === criterion.criterion" :id="principleIndex+'.'+(index+1)" :auditId="auditId" :auditor="auditor" :criteria="criterion" :certificationId="certificationId" :principleId="principle.principle" :impactArea="impactArea" :status="auditStatus" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Criteria from './Criteria.vue';
import Indicator from './Indicator.vue';

export default {
  name: 'Principle',
  components: { Indicator, Criteria },
  props: ['auditId', 'principleIndex', 'principle', 'impactArea', 'events', 'auditStatus', 'auditor', 'certificationId'],
  data() {
    return {
      activeTab: 1,
      indicators: [],
      section: this.principle && this.principle.criteria.length > 0 ? this.principle.criteria[0].id : null
    };
  },
  mounted() {
    this.getIndicators();
    this.activeTab = this.principle.criteria.length > 0 ? this.principle.criteria[0].criterion : 1;
  },
  methods: {
    tab(tabname) {
      this.activeTab = tabname;
    },
    async getIndicators() {
      this.indicators = [];
      try {
        const { data } = await this.$api.get(`audits/certifications/${this.certificationId}/impact_areas/${this.impactArea}/principles/${this.principle.principle}/control_points`);
        this.indicators = data;
      } catch (e) {
        console.error(e);
      }
    },
    getPityName(name) {
      return name.substring(name.indexOf(' '));
    }
  }
}
</script>

<style scoped>
</style>
